import { ColumnConfig, ExtendedDatevBookingData } from '../constants';

const escapeValue = (value: string) => `"${value.replace(/"/g, '""')}"`;

export const bookingDataToCsv = (
  rows: ExtendedDatevBookingData[],
  columns: ColumnConfig[]
): string => {
  const header = columns.map(col => escapeValue(col.label)).join(',');

  const lines = rows.map(row =>
    columns
      .map(col => {
        const cell = row[col.key];
        if (cell === null || cell === undefined) return '';
        return escapeValue(String(cell));
      })
      .join(',')
  );

  return [header, ...lines].join('\n');
};
